import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import SnackbarContent from "components/Snackbar/SnackbarContent";
import { useTranslation } from 'react-i18next';
import ClipLoader from "react-spinners/ClipLoader";
import Axios from "axios";
import config from "assets/config/config.json";

import AnyQuestionsComponent from "components/MyComponents/AnyQuestionsComponent";
import PaymentFormFirstTimeComponent from "components/PaymentFormFirstTime/PaymentFormFirstTimeComponent";
import { withRouter } from "react-router-dom";


const useStyles = makeStyles(styles);

function PaymentInfoPage(props) {
  const { location, history } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const { ...rest } = props;
  const [error, setError] = React.useState(null);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [items, setItems] = React.useState(null);
  const showAgreeTerms = location.search == "?errorid=404";
  const showCardError = location.search == "?errorid=400";

  console.log('Main page logic entered');

  // Note: the empty deps array [] means
  // this useEffect will run once
  // similar to componentDidMount()
  React.useEffect(() => {
    Axios.get(config.checklogin)
      .then(
        (_result) => {
          Axios.get(config.getQuote)
            .then(
              (result) => {
                setItems(result.data);
                setIsLoaded(true);
              },
              (error) => {
                setIsLoaded(true);
                setError(error);
              })
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          setIsLoaded(false);
          setError(error);
        }
      )
  }, []);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (error && error.response && error.response.status === 403) {
    history.replace('/auth');
    window.location.reload();
    console.log('PaymentInfoPage: Error status 403');
  }
  else if (error) {
    history.replace('/help');
    window.location.reload();
    console.log('PaymentInfoPage: Generic error');
  }
  else if (!isLoaded) {
    console.log('PaymentInfoPage: Not Loaded');
    return (
      <div>
    <Header key={1}
          color="dark"
          sticky
          breadcrumb={[{ text: t("PersonalInformationHeader_Title"), selected: false, isbutton: false }, { text: t("PersonalInformationHeader_PaymentMethod"), selected: true, isbutton: false }]}
          />
      <div
        style={{
          position: 'absolute', left: '50%', top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <ClipLoader

          size={200}
          color={"#504a4a"}
        />
      </div></div>);
  }
  else if (items && items.isExempt) {
    history.replace('/');
    window.location.reload();
    console.log('MainPage: Exempt');
  }
  else {
    console.log('MainPage: Show Import');
    return (
      <div>
        <Header key={2}
          color="dark"
          sticky
          brand={<img style={{ filter: "brightness(0) invert(1)" }}
              src={brandImage}
              className={classes.img}
              alt="brand"
          />}
          userData={items}
          breadcrumb={[{ text: t("PersonalInformationHeader_Title"), selected: false, isbutton: false }, { text: t("PersonalInformationHeader_PaymentMethod"), selected: true, isbutton: false }]}
          {...rest}
        />
        <SnackbarContent
          message={
            <span>
              <b>{t("Alert") + ':'}</b> {t("AlertText")}
            </span>
          }
          id="notification"
          color="warning"
          icon="info_outline"
          close
        />
        <SnackbarContent
          message={
            <span style={{ padding: "10px 0" }}>
              {t("Fields")}
            </span>
          }
          id="info"
          color="danger"
          icon="info_outline"
          close
        />
        <SnackbarContent
          message={
            <span>
              {t("ServerError")}
            </span>
          }
          id="error"
          color="danger"
          icon="info_outline"
          close
        />
        <PaymentFormFirstTimeComponent showAgreeTerms={showAgreeTerms} showCardError={showCardError} userData={items} />
        <AnyQuestionsComponent />
        <Footer whiteFont />
      </div>

    );
  }
}
export default withRouter(PaymentInfoPage);